"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _parseCookieAsObject2 = _interopRequireDefault(require("./parseCookieAsObject"));

var _getCookie = _interopRequireDefault(require("./getCookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default() {
  var uprops = (0, _getCookie["default"])('uprops');
  if (!uprops) return {};

  var _parseCookieAsObject = (0, _parseCookieAsObject2["default"])(uprops),
      age = _parseCookieAsObject.ag,
      gender = _parseCookieAsObject.gc,
      id = _parseCookieAsObject.ui,
      transactions = _parseCookieAsObject.to,
      deliveryPassStatus = _parseCookieAsObject.dp;

  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, id && {
    id: id.replace(/[{}]/g, '')
  }), {}, {
    loggedIn: true
  }, age && {
    age: age
  }), gender !== 'not-known' && {
    gender: gender
  }), {}, {
    hasTransacted: transactions > 0
  }, deliveryPassStatus && {
    deliveryPassStatus: deliveryPassStatus
  });
};

exports["default"] = _default;